const $ = jQuery.noConflict();

export default function hsFormHandlers() {
    window.addEventListener("message", (event) => {
        if (
            event.data.type === "hsFormCallback" &&
            event.data.eventName === "onFormSubmitted"
        ) {
            $("body").addClass("form-submitted");
        }
    });
}
